export const ENUM_STORAGE_BROWSER_LANGUAGE = 'i18nextLng';
export const ENUM_STORAGE_WEBPACK_VERSION = 'ENUM_STORAGE_WEBPACK_VERSION';
